import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import * as React from 'react';

interface IHeadingProps extends React.PropsWithChildren {
	type: 'A1' | 'A2' | 'B1' | 'D1'; // The Travelnest style component
	htmlElement?: 'H1' | 'H2' | 'H3' | 'H4' | 'H5'; // The corresponding html element. This should not be used for styling, instead use A values.
}

const styleMap: Record<IHeadingProps['type'], {}> = {
	A1: theme.typography.RWB140,
	A2: theme.typography.RWB130,
	B1: theme.typography.RWB120,
	D1: theme.typography.RWB110,
};

export const Heading: React.FC<IHeadingProps> = ({ type, htmlElement, children }) => {
	const styleType = (type || 'B1');
	const tag = (htmlElement || 'H2').toLowerCase();

	const StyledHeading = styled[tag]`
		margin-top: var(--margin-top-${styleType.toLowerCase()});
		color: ${theme.colors.typography.heading};
		${styleMap[styleType]};
	`;

	return <StyledHeading>{children}</StyledHeading>;
};
